import {useFormikContext} from 'formik'
import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {ISettingsForm} from '../../../../../../_metronic/helpers/custom/tsHelpers/profileHelpers'
import {InputTemplate} from '../../../../../modules/custom/form-elements/InputTemplate'

const ParcelArchiveSetting = () => {
  const intl = useIntl()

  const {setFieldValue, values} = useFormikContext<ISettingsForm>()
  return (
    <div>
      <span className='form-check-label d-flex flex-column align-items-start mb-5'>
        <span className='fw-bolder fs-5 '>
          <FormattedMessage id='PROFILE.PAGE.SETTINGS.PARCEL_ARCHIVE' />:
        </span>
      </span>{' '}
      <div className='d-flex mw-500px '>
        <InputTemplate
          inputName='parcel_archive'
          type='radio'
          title={intl.formatMessage({id: 'PROFILE.PAGE.SETTINGS.PARCEL_ARCHIVE.MANUAL'})}
          checkboxProps={{
            checked: values.parcel_archive === 0 ? true : false,
            disabled: false,
            setFieldValue: setFieldValue,
            value: 0,
            inputName: 'parcel_archive',
            type: 'radio',
          }}
        />{' '}
        <InputTemplate
          inputName='parcel_archive'
          type='radio'
          title={intl.formatMessage({id: 'PROFILE.PAGE.SETTINGS.PARCEL_ARCHIVE.AUTO'})}
          checkboxProps={{
            checked: values.parcel_archive === 1 ? true : false,
            disabled: false,
            setFieldValue: setFieldValue,
            value: 1,
            inputName: 'parcel_archive',
            type: 'radio',
          }}
        />
      </div>
    </div>
  )
}

export default ParcelArchiveSetting
